import React from 'react';
import { connect } from 'react-redux';
import ScoringLoader, { endpointNames } from 'general/js/loaders/scoring-loader';
import { ReactModal } from 'components/modal';
import { TeeTimesList } from 'components/tee-times';
import { LiveCardHighlights } from 'components/live-card-highlights';
import { bemClasses, LivePreMessage } from 'components/live-pre-message';
import {
    tabsTypes,
    getLiveHoleTabs,
} from './enums';
import LiveHoleView from './live-hole-view';
import LiveHoleHero from './live-hole-hero';
import LiveHoleStats from './live-hole-stats';

class LiveHoleLayout extends React.Component {
    constructor(props) {
        super(props);

        this.tabsInitial = getLiveHoleTabs();

        this.state = {
            activeHoleId: this.props.holeId,
            selectedTabId: tabsTypes.overview.id,
            isExpanded: false,
        };
    }

    componentDidMount() {
        ScoringLoader.subscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.subscribe(endpointNames.PLAYERS);
        ScoringLoader.subscribe(endpointNames.COURSE);
        ScoringLoader.subscribe(endpointNames.STATISTICS);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(endpointNames.LIVE_SCANNER);
        ScoringLoader.unsubscribe(endpointNames.PLAYERS);
        ScoringLoader.unsubscribe(endpointNames.COURSE);
        ScoringLoader.unsubscribe(endpointNames.STATISTICS);
    }

    onClickToggleOverview = () => {
        this.setState({ isExpanded: !this.state.isExpanded });
    }

    renderHole = (holeId) => {

        this.setState({
            activeHoleId: holeId,
            selectedTabId: tabsTypes.overview.id,
            isExpanded: false,
        });
    }

    setTab = (tabId) => {
        this.setState({ selectedTabId: tabId });
    }

    render() {
        const {
            scoringCourse,
            scoringStats,
            liveScanner
        } = this.props;

        if (!liveScanner || !scoringCourse || !scoringStats) return null;

        const activeHole = scoringCourse.holes.find((hole) => hole.id === this.state.activeHoleId);        

        return (
            <ReactModal isOpen={this.props.holeId !== null} onCloseCb={this.props.onClose}>
                <article className="live-hole">
                    {
                        !activeHole &&
                        <LivePreMessage
                            model={{
                                title: '',
                                body: 'Hole data coming soon'
                            }}
                            bemList={[bemClasses.LIGHT]}
                        />
                    }
                    {
                        activeHole &&
                        <React.Fragment>
                            <LiveHoleHero
                                tabs={this.tabs}
                                activeTabId={this.state.selectedTabId}
                                holesLength={scoringCourse.holes.length}
                                hole={activeHole}
                                isExpanded={this.state.isExpanded}
                                renderHole={this.renderHole}
                                setTab={this.setTab}
                                onClickToggleOverview={this.onClickToggleOverview}
                            />
                            {
                                this.state.selectedTabId === tabsTypes.overview.id &&
                                <React.Fragment>
                                    <LiveHoleView hole={activeHole} />
                                    <TeeTimesList
                                        groups={activeHole.groups}
                                        sitecorePlayers={this.props.sitecorePlayers}
                                        isOnHole
                                    />
                                        {
                                        liveScanner.liveComponents.course.show ? 
                                            <LiveHoleStats
                                                liveScanner={liveScanner}
                                                scoringStats={scoringStats}
                                                activeHole={activeHole}
                                            /> : liveScanner.liveComponents.course.subtitle                                     
                                    }
                                </React.Fragment>
                            }
                            {
                                this.state.selectedTabId === tabsTypes.highlights.id &&
                                <LiveCardHighlights groups={this.highlightGroups} />
                            }
                        </React.Fragment>
                    }
                </article>
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => ({
    liveScanner: state.scoring[endpointNames.LIVE_SCANNER],
    sitecorePlayers: state.scoring[endpointNames.PLAYERS],
    scoringCourse: state.scoring[endpointNames.COURSE],
    scoringStats: state.scoring[endpointNames.STATISTICS]
});

const LiveHoleLayoutContainer = connect(
    mapStateToProps
)(LiveHoleLayout);

export default LiveHoleLayoutContainer;
